'use strict';
module.exports = require('./Checkbox.vue');